module.exports = __webpack_public_path__ + "img/desilva.7a96baf7.jpg";